import React from 'react';
import PropTypes from 'prop-types';
import { ComponentLoader } from '../../../global/ComponentLoader/ComponentLoader';

const importFunc = () => {
    return import(
        /* webpackChunkName: "PdpSourcingModal" */
        'dibs-trade-sourcing/exports/PdpSourcingModal'
    ).then(({ PdpSourcingModal }) => PdpSourcingModal);
};

export function PdpSharedSourcingModalLoader(props) {
    return (
        <ComponentLoader
            {...props}
            load={props.isOpen}
            importFunc={importFunc}
            useLoadingComponent={false}
        />
    );
}

PdpSharedSourcingModalLoader.propTypes = {
    environment: PropTypes.object.isRequired,
    isOpen: PropTypes.bool.isRequired,
    itemId: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
    showInitialPrompt: PropTypes.bool,
};
